<app-modal-header [title]="'Share link with students'"></app-modal-header>
<div class="modal-body pt-4">
    <div class="important-desc mb-2 modal-body-text">
        <app-icon [type]="'file-dots'" class="me-3 red"></app-icon> Student work results not
        available
    </div>

    <div class="important-desc mb-7 modal-body-text">
        <app-icon [type]="'lock-open'" class="me-3"></app-icon> Student sign in not required
    </div>
    <span *ngIf="!resourceIsVideo" class="version-placeholder mb-4 modal-body-text"
        >This link opens the resource page optimized for student viewing.
    </span>
    <span *ngIf="resourceIsVideo" class="version-placeholder mb-4 modal-body-text"
        >Choose version of resource to share</span
    >
    <app-copy-link
        [buttonClasses]="'modal-button-padding'"
        *ngIf="resourceIsVideo"
        [isButton]="true"
        [label]="focusViewLabel"
        [shareLink]="focusLink"
        class="d-inline-block"
    ></app-copy-link>
    <app-copy-link
        [buttonClasses]="'modal-button-padding'"
        [isButton]="true"
        [label]="fullViewLabel"
        [shareLink]="fullViewLink"
        class="d-inline-block"
    ></app-copy-link>
    <span class="my-6 d-block modal-body-text">
        Want to build a lesson with this resource first? Go to our
        <app-link
            (click)="activeModal.close()"
            [appRouterLink]="'/tools/lessonbuilder/'"
            class="lesson-link"
            >Lesson Builder</app-link
        >
        to add instructions, questions, and additional media slides.
    </span>
    <div class="d-flex justify-content-end action">
        <button (click)="activeModal.close()" class="btn btn-outline-primary" type="button">
            Done
        </button>
    </div>
</div>
